import { Component, createRef } from "react";




import { 
  Card,
  Section,
} from 'react-bulma-components';
import axios from "axios";
import { baseUrl } from "helpers/Url";


class InputsCreate extends Component{
  state = {
    data: null
  }
  // constructor (props) {
  //   super(props)
  // }
  renderDetalle = () => {
    if ((typeof this.props.detalle).toString().toLocaleLowerCase() === 'object') {
      if (this.props.detalle) {
        return this.props.detalle
      } else 
        return ''
    } else if ((typeof this.props.detalle).toString().toLocaleLowerCase() === 'string'){
      return (<p>{ this.props.detalle }</p>)
    }
    return ''
  }
  renderType = () => {
    switch (this.props.type) {
      case 'text':
        return (
          <>
          <div className="control   is-clearfix is-fullwidth">
                <input type="text" placeholder={ this.props.placeholder } id={ this.props.nameKey }  name={ this.props.nameKey }
                  ref={this.props.referencia}
                  onChange={ this.props.onChange }
                   className="input form-control" minLength={ this.props.limit && this.props.minLength } maxLength={ this.props.limit && this.props.maxLength }  />
              </div>
              { (this.props.limit) && (<p className="help">{ this.props.minLength } / { this.props.maxLength } </p>)}
              
          </>
        )
      case 'boolean':
        return (
          <>
          <label className="switch is-rounded">
            <input type="checkbox" true-value="true" value="1" id={ this.props.nameKey }  
            onChange={ this.props.onChange }
            name={ this.props.nameKey }/>
              <span className="check"></span>
              <span className="control-label"> </span>
            </label>
              
          </>
        )
      case 'number':
        return (
          <>
          <div className="control   is-clearfix">
                <input type="number" placeholder={ this.props.placeholder } id={ this.props.nameKey }  
                onChange={ this.props.onChange }
                name={ this.props.nameKey }
                   className="input form-control" min={ this.props.limit && this.props.minLength } max={ this.props.limit && this.props.maxLength } step="any" />
              </div>
              
              
          </>
        )
        case 'textarea':
          return (
            <>
            <textarea placeholder={ this.placeholder } id={ this.props.nameKey }  
            onChange={ this.props.onChange }
            name={ this.props.nameKey }  minLength={ this.props.minLength } maxLength={ this.props.maxLength }  className="textarea"></textarea>
            
                { (this.props.minLength && this.props.maxLength) && (<span className="help counter">{ this.props.minLength } / { this.props.maxLength } </span>)}
                
            </>
          )
        case 'select':
          return (
            <div className="control "><span className="select is-empty is-clearfix is-fullwidth"> 
                          <select required="required" id={ this.props.nameKey } 
                          onChange={ this.props.onChange }
                          name={ this.props.nameKey } disabled={ this.props.forSelect.data.length === 0 }
                          ref={this.props.referencia}>
                            <option value="-1"> {this.props.byDefault ? this.props.byDefault : "-- Seleccione --"}</option>
                            { this.props.forSelect.data }

                          </select></span></div>
          )
        
        default:
          return ''
    }
  }
  render () {
    return (
     
      <div className="field is-horizontal">
        {this.props.label?
        <div className="field-label is-normal"><label htmlFor={ this.props.nameKey } className="label">{ this.props.label }</label></div>
        :''
       }<div className="field-body">
          <div className="field columns">
            <div className="field column">
                { this.renderType()}           
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default InputsCreate

